import { render, staticRenderFns } from "./PageRender.vue?vue&type=template&id=c212bd5c&"
import script from "./PageRender.vue?vue&type=script&lang=js&"
export * from "./PageRender.vue?vue&type=script&lang=js&"
import style0 from "./PageRender.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports